module.exports = __webpack_public_path__ + "img/docAppointRes_b.b36acc0e.png";